import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DispositionState {
    isDisposition: boolean; // Whether disposition is active
    isModal: boolean;
    isOutbound:boolean;      // Example of another value related to disposition
}

const initialState: DispositionState = {
    isDisposition: false, // Default state for disposition
    isModal: false,         // Default value for some related data
    isOutbound:false,
};

const dispositionSlice = createSlice({
    name: 'disposition',
    initialState,
    reducers: {
        setIsDisposition: (state, action: PayloadAction<boolean>) => {
            state.isDisposition = action.payload; // Update isDisposition with the action value
        },
        setisModal: (state, action: PayloadAction<boolean>) => {
            state.isModal = action.payload; // Update someValue with the action value
        },
        setisOutbound: (state, action: PayloadAction<boolean>) => {
            state.isOutbound = action.payload; // Ensure this remains a boolean
        },
        
    },
});

// Export the actions
export const { setIsDisposition, setisModal,setisOutbound } = dispositionSlice.actions;

// Export the reducer for store configuration
export default dispositionSlice.reducer;
